import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const resetInternalRequestApi = async (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/opco/internal/users/me/reset-request/';

  return authApiService.POST(uri, {});
};
